// Per-conversation agent-assistant preferences stored in localStorage.
// Scope is intentionally per-conversation (not global): an agent may want the
// AI to auto-suggest replies on one chat but not another.
// Shape: { autoReplyOn: boolean }
const STORAGE_PREFIX = 'ai_assist_settings';

export const DEFAULT_PREFS = Object.freeze({
  autoReplyOn: false,
});

const buildKey = (accountId, conversationId) =>
  `${STORAGE_PREFIX}:${accountId}:${conversationId}`;

export const loadPrefs = (accountId, conversationId) => {
  try {
    const raw = window.localStorage.getItem(
      buildKey(accountId, conversationId)
    );
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch (err) {
    return { ...DEFAULT_PREFS };
  }
};

export const savePrefs = (accountId, conversationId, prefs) => {
  try {
    window.localStorage.setItem(
      buildKey(accountId, conversationId),
      JSON.stringify(prefs)
    );
  } catch (err) {
    // localStorage may be disabled or quota exceeded; fail silently.
  }
};
